import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BlockScalar: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  JsonScalar: any;
};

export type ActiontickerComponent = {
  __typename?: 'ActiontickerComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  background_color?: Maybe<Scalars['JsonScalar']>;
  component?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['BlockScalar']>;
  text_color?: Maybe<Scalars['JsonScalar']>;
};

export type ActiontickerItem = {
  __typename?: 'ActiontickerItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ActiontickerComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ActiontickerItems = {
  __typename?: 'ActiontickerItems';
  items?: Maybe<Array<Maybe<ActiontickerItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Alternate = {
  __typename?: 'Alternate';
  fullSlug: Scalars['String'];
  id: Scalars['Int'];
  isFolder?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  slug: Scalars['String'];
};

export type Asset = {
  __typename?: 'Asset';
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  focus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type BlogcategoryComponent = {
  __typename?: 'BlogcategoryComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BlogcategoryFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
};

export type BlogcategoryItem = {
  __typename?: 'BlogcategoryItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BlogcategoryComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BlogcategoryItems = {
  __typename?: 'BlogcategoryItems';
  items?: Maybe<Array<Maybe<BlogcategoryItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BlogoverviewComponent = {
  __typename?: 'BlogoverviewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  bg?: Maybe<Asset>;
  component?: Maybe<Scalars['String']>;
  featuredItem?: Maybe<Story>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};


export type BlogoverviewComponentFeaturedItemArgs = {
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
};

export type BlogoverviewFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  featuredItem?: Maybe<FilterQueryOperations>;
};

export type BlogoverviewItem = {
  __typename?: 'BlogoverviewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BlogoverviewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BlogoverviewItems = {
  __typename?: 'BlogoverviewItems';
  items?: Maybe<Array<Maybe<BlogoverviewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type BlogpageComponent = {
  __typename?: 'BlogpageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Story>>>;
  component?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['BlockScalar']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  person?: Maybe<Story>;
  relatedArticles?: Maybe<Array<Maybe<Story>>>;
  seo?: Maybe<Scalars['JsonScalar']>;
  text?: Maybe<Scalars['String']>;
};


export type BlogpageComponentCategoriesArgs = {
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
};


export type BlogpageComponentPersonArgs = {
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
};


export type BlogpageComponentRelatedArticlesArgs = {
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
};

export type BlogpageFilterQuery = {
  description?: Maybe<FilterQueryOperations>;
  text?: Maybe<FilterQueryOperations>;
  person?: Maybe<FilterQueryOperations>;
  relatedArticles?: Maybe<FilterQueryOperations>;
  categories?: Maybe<FilterQueryOperations>;
};

export type BlogpageItem = {
  __typename?: 'BlogpageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<BlogpageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type BlogpageItems = {
  __typename?: 'BlogpageItems';
  items?: Maybe<Array<Maybe<BlogpageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CollectionComponent = {
  __typename?: 'CollectionComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  additional_data?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Scalars['String']>;
  page_title?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CollectionFilterQuery = {
  link_text?: Maybe<FilterQueryOperations>;
  title?: Maybe<FilterQueryOperations>;
  page_title?: Maybe<FilterQueryOperations>;
  meta_description?: Maybe<FilterQueryOperations>;
  meta_keywords?: Maybe<FilterQueryOperations>;
};

export type CollectionItem = {
  __typename?: 'CollectionItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<CollectionComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type CollectionItems = {
  __typename?: 'CollectionItems';
  items?: Maybe<Array<Maybe<CollectionItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ContentItem = {
  __typename?: 'ContentItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<Scalars['JsonScalar']>;
  content_string?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ContentItems = {
  __typename?: 'ContentItems';
  items?: Maybe<Array<Maybe<ContentItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Datasource = {
  __typename?: 'Datasource';
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type DatasourceEntries = {
  __typename?: 'DatasourceEntries';
  items: Array<DatasourceEntry>;
  total: Scalars['Int'];
};

export type DatasourceEntry = {
  __typename?: 'DatasourceEntry';
  dimensionValue?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Datasources = {
  __typename?: 'Datasources';
  items: Array<Datasource>;
};

export type DynamicpageComponent = {
  __typename?: 'DynamicpageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  noIndex?: Maybe<Scalars['Boolean']>;
  sections?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
};

export type DynamicpageFilterQuery = {
  noIndex?: Maybe<FilterQueryOperations>;
};

export type DynamicpageItem = {
  __typename?: 'DynamicpageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<DynamicpageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type DynamicpageItems = {
  __typename?: 'DynamicpageItems';
  items?: Maybe<Array<Maybe<DynamicpageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FilterQueryOperations = {
  /** Matches exactly one value */
  in?: Maybe<Scalars['String']>;
  /** Matches all without the given value */
  not_in?: Maybe<Scalars['String']>;
  /** Matches exactly one value with a wildcard search using * */
  like?: Maybe<Scalars['String']>;
  /** Matches all without the given value */
  not_like?: Maybe<Scalars['String']>;
  /** Matches any value of given array */
  in_array?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Matches any value of given array */
  any_in_array?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Must match all values of given array */
  all_in_array?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Greater than date (Exmples: 2019-03-03 or 2020-03-03T03:03:03) */
  gt_date?: Maybe<Scalars['ISO8601DateTime']>;
  /** Less than date (Format: 2019-03-03 or 2020-03-03T03:03:03) */
  lt_date?: Maybe<Scalars['ISO8601DateTime']>;
  /** Greater than integer value */
  gt_int?: Maybe<Scalars['Int']>;
  /** Less than integer value */
  lt_int?: Maybe<Scalars['Int']>;
  /** Matches exactly one integer value */
  in_int?: Maybe<Scalars['Int']>;
  /** Greater than float value */
  gt_float?: Maybe<Scalars['Float']>;
  /** Less than float value */
  lt_float?: Maybe<Scalars['Float']>;
};

export type FooterComponent = {
  __typename?: 'FooterComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  link_list?: Maybe<Scalars['BlockScalar']>;
};

export type FooterItem = {
  __typename?: 'FooterItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<FooterComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type FooterItems = {
  __typename?: 'FooterItems';
  items?: Maybe<Array<Maybe<FooterItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FooternewComponent = {
  __typename?: 'FooternewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  background_color?: Maybe<Scalars['JsonScalar']>;
  blocks?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  font_color?: Maybe<Scalars['JsonScalar']>;
  footer_bottom_links?: Maybe<Scalars['BlockScalar']>;
  footer_bottom_text_blocks?: Maybe<Scalars['BlockScalar']>;
};

export type FooternewItem = {
  __typename?: 'FooternewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<FooternewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type FooternewItems = {
  __typename?: 'FooternewItems';
  items?: Maybe<Array<Maybe<FooternewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type HomeComponent = {
  __typename?: 'HomeComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['BlockScalar']>;
  blog?: Maybe<Scalars['BlockScalar']>;
  brands?: Maybe<Scalars['BlockScalar']>;
  campaign?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  header_button?: Maybe<Scalars['String']>;
  how?: Maybe<Scalars['BlockScalar']>;
  image?: Maybe<Asset>;
  meals_buttonText?: Maybe<Scalars['String']>;
  meals_collection?: Maybe<Scalars['BlockScalar']>;
  meals_gallery?: Maybe<Array<Maybe<Asset>>>;
  meals_link?: Maybe<Link>;
  meals_title?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['BlockScalar']>;
  reviews?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  why?: Maybe<Scalars['BlockScalar']>;
};

export type HomeFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  subtitle?: Maybe<FilterQueryOperations>;
  header_button?: Maybe<FilterQueryOperations>;
  meals_title?: Maybe<FilterQueryOperations>;
  meals_buttonText?: Maybe<FilterQueryOperations>;
};

export type HomeItem = {
  __typename?: 'HomeItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<HomeComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type HomeItems = {
  __typename?: 'HomeItems';
  items?: Maybe<Array<Maybe<HomeItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type HomecopyComponent = {
  __typename?: 'HomecopyComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['BlockScalar']>;
  blog?: Maybe<Scalars['BlockScalar']>;
  brands?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  header_button?: Maybe<Scalars['String']>;
  how?: Maybe<Scalars['BlockScalar']>;
  image?: Maybe<Asset>;
  meals_buttonText?: Maybe<Scalars['String']>;
  meals_collection?: Maybe<Scalars['BlockScalar']>;
  meals_gallery?: Maybe<Array<Maybe<Asset>>>;
  meals_link?: Maybe<Link>;
  meals_title?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['BlockScalar']>;
  reviews?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  why?: Maybe<Scalars['BlockScalar']>;
};

export type HomecopyFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  subtitle?: Maybe<FilterQueryOperations>;
  header_button?: Maybe<FilterQueryOperations>;
  meals_title?: Maybe<FilterQueryOperations>;
  meals_buttonText?: Maybe<FilterQueryOperations>;
};

export type HomecopyItem = {
  __typename?: 'HomecopyItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<HomecopyComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type HomecopyItems = {
  __typename?: 'HomecopyItems';
  items?: Maybe<Array<Maybe<HomecopyItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type HomesectionComponent = {
  __typename?: 'HomesectionComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  blocks?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  renderType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type HomesectionFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  renderType?: Maybe<FilterQueryOperations>;
};

export type HomesectionItem = {
  __typename?: 'HomesectionItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<HomesectionComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type HomesectionItems = {
  __typename?: 'HomesectionItems';
  items?: Maybe<Array<Maybe<HomesectionItem>>>;
  total?: Maybe<Scalars['Int']>;
};



export type LandingComponent = {
  __typename?: 'LandingComponent';
  Image?: Maybe<Asset>;
  Sections?: Maybe<Scalars['BlockScalar']>;
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  header_button?: Maybe<Scalars['String']>;
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Scalars['String']>;
  og_image?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LandingFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  subtitle?: Maybe<FilterQueryOperations>;
  meta_description?: Maybe<FilterQueryOperations>;
  meta_keywords?: Maybe<FilterQueryOperations>;
  header_button?: Maybe<FilterQueryOperations>;
};

export type LandingItem = {
  __typename?: 'LandingItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<LandingComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type LandingItems = {
  __typename?: 'LandingItems';
  items?: Maybe<Array<Maybe<LandingItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Link = {
  __typename?: 'Link';
  cachedUrl: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  fieldtype: Scalars['String'];
  id: Scalars['String'];
  linktype: Scalars['String'];
  story?: Maybe<Story>;
  url: Scalars['String'];
};

export type LinkEntries = {
  __typename?: 'LinkEntries';
  items: Array<LinkEntry>;
};

export type LinkEntry = {
  __typename?: 'LinkEntry';
  id?: Maybe<Scalars['Int']>;
  isFolder?: Maybe<Scalars['Boolean']>;
  isStartpage?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type MealssettingsComponent = {
  __typename?: 'MealssettingsComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['JsonScalar']>;
  meals_groups?: Maybe<Scalars['BlockScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type MealssettingsFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
};

export type MealssettingsItem = {
  __typename?: 'MealssettingsItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<MealssettingsComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type MealssettingsItems = {
  __typename?: 'MealssettingsItems';
  items?: Maybe<Array<Maybe<MealssettingsItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type NavigationComponent = {
  __typename?: 'NavigationComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  link_list?: Maybe<Scalars['BlockScalar']>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<NavigationComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type NavigationItems = {
  __typename?: 'NavigationItems';
  items?: Maybe<Array<Maybe<NavigationItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type OverviewsettingsComponent = {
  __typename?: 'OverviewsettingsComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  disable_checkout?: Maybe<Scalars['Boolean']>;
  disabled_checkout_text?: Maybe<Scalars['JsonScalar']>;
  fh_delivery_cost?: Maybe<Scalars['String']>;
  shopify_delivery_cost?: Maybe<Scalars['String']>;
  tips?: Maybe<Scalars['BlockScalar']>;
};

export type OverviewsettingsFilterQuery = {
  shopify_delivery_cost?: Maybe<FilterQueryOperations>;
  fh_delivery_cost?: Maybe<FilterQueryOperations>;
  disable_checkout?: Maybe<FilterQueryOperations>;
};

export type OverviewsettingsItem = {
  __typename?: 'OverviewsettingsItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<OverviewsettingsComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type OverviewsettingsItems = {
  __typename?: 'OverviewsettingsItems';
  items?: Maybe<Array<Maybe<OverviewsettingsItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PageComponent = {
  __typename?: 'PageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
};

export type PageItem = {
  __typename?: 'PageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PageItems = {
  __typename?: 'PageItems';
  items?: Maybe<Array<Maybe<PageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PdpsettingsComponent = {
  __typename?: 'PdpsettingsComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  banner_image?: Maybe<Asset>;
  component?: Maybe<Scalars['String']>;
};

export type PdpsettingsItem = {
  __typename?: 'PdpsettingsItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PdpsettingsComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PdpsettingsItems = {
  __typename?: 'PdpsettingsItems';
  items?: Maybe<Array<Maybe<PdpsettingsItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PersonComponent = {
  __typename?: 'PersonComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  avatar?: Maybe<Asset>;
  component?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PersonFilterQuery = {
  name?: Maybe<FilterQueryOperations>;
};

export type PersonItem = {
  __typename?: 'PersonItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PersonComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PersonItems = {
  __typename?: 'PersonItems';
  items?: Maybe<Array<Maybe<PersonItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PostComponent = {
  __typename?: 'PostComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  author?: Maybe<Story>;
  component?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  long_text?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};


export type PostComponentAuthorArgs = {
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
};

export type PostFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  author?: Maybe<FilterQueryOperations>;
};

export type PostItem = {
  __typename?: 'PostItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<PostComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type PostItems = {
  __typename?: 'PostItems';
  items?: Maybe<Array<Maybe<PostItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ProductComponent = {
  __typename?: 'ProductComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  featured_products?: Maybe<Scalars['JsonScalar']>;
  featured_products_title?: Maybe<Scalars['String']>;
};

export type ProductFilterQuery = {
  featured_products_title?: Maybe<FilterQueryOperations>;
};

export type ProductItem = {
  __typename?: 'ProductItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ProductComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ProductItems = {
  __typename?: 'ProductItems';
  items?: Maybe<Array<Maybe<ProductItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ProductlistingComponent = {
  __typename?: 'ProductlistingComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  title?: Maybe<Scalars['String']>;
};

export type ProductlistingFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  description?: Maybe<FilterQueryOperations>;
};

export type ProductlistingItem = {
  __typename?: 'ProductlistingItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ProductlistingComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ProductlistingItems = {
  __typename?: 'ProductlistingItems';
  items?: Maybe<Array<Maybe<ProductlistingItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type QueryType = {
  __typename?: 'QueryType';
  ActiontickerItem?: Maybe<ActiontickerItem>;
  ActiontickerItems?: Maybe<ActiontickerItems>;
  BlogcategoryItem?: Maybe<BlogcategoryItem>;
  BlogcategoryItems?: Maybe<BlogcategoryItems>;
  BlogoverviewItem?: Maybe<BlogoverviewItem>;
  BlogoverviewItems?: Maybe<BlogoverviewItems>;
  BlogpageItem?: Maybe<BlogpageItem>;
  BlogpageItems?: Maybe<BlogpageItems>;
  CollectionItem?: Maybe<CollectionItem>;
  CollectionItems?: Maybe<CollectionItems>;
  ContentNode?: Maybe<ContentItem>;
  ContentNodes?: Maybe<ContentItems>;
  DatasourceEntries?: Maybe<DatasourceEntries>;
  Datasources?: Maybe<Datasources>;
  DynamicpageItem?: Maybe<DynamicpageItem>;
  DynamicpageItems?: Maybe<DynamicpageItems>;
  FooterItem?: Maybe<FooterItem>;
  FooterItems?: Maybe<FooterItems>;
  FooternewItem?: Maybe<FooternewItem>;
  FooternewItems?: Maybe<FooternewItems>;
  HomeItem?: Maybe<HomeItem>;
  HomeItems?: Maybe<HomeItems>;
  HomecopyItem?: Maybe<HomecopyItem>;
  HomecopyItems?: Maybe<HomecopyItems>;
  HomesectionItem?: Maybe<HomesectionItem>;
  HomesectionItems?: Maybe<HomesectionItems>;
  LandingItem?: Maybe<LandingItem>;
  LandingItems?: Maybe<LandingItems>;
  Links?: Maybe<LinkEntries>;
  MealssettingsItem?: Maybe<MealssettingsItem>;
  MealssettingsItems?: Maybe<MealssettingsItems>;
  NavigationItem?: Maybe<NavigationItem>;
  NavigationItems?: Maybe<NavigationItems>;
  OverviewsettingsItem?: Maybe<OverviewsettingsItem>;
  OverviewsettingsItems?: Maybe<OverviewsettingsItems>;
  PageItem?: Maybe<PageItem>;
  PageItems?: Maybe<PageItems>;
  PdpsettingsItem?: Maybe<PdpsettingsItem>;
  PdpsettingsItems?: Maybe<PdpsettingsItems>;
  PersonItem?: Maybe<PersonItem>;
  PersonItems?: Maybe<PersonItems>;
  PostItem?: Maybe<PostItem>;
  PostItems?: Maybe<PostItems>;
  ProductItem?: Maybe<ProductItem>;
  ProductItems?: Maybe<ProductItems>;
  ProductlistingItem?: Maybe<ProductlistingItem>;
  ProductlistingItems?: Maybe<ProductlistingItems>;
  RateLimit?: Maybe<RateLimit>;
  Space?: Maybe<Space>;
  Tags?: Maybe<Tags>;
  TermsandconditionsItem?: Maybe<TermsandconditionsItem>;
  TermsandconditionsItems?: Maybe<TermsandconditionsItems>;
  ThemeboxmealItem?: Maybe<ThemeboxmealItem>;
  ThemeboxmealItems?: Maybe<ThemeboxmealItems>;
  ThemeboxoverviewItem?: Maybe<ThemeboxoverviewItem>;
  ThemeboxoverviewItems?: Maybe<ThemeboxoverviewItems>;
  ThemeboxpageItem?: Maybe<ThemeboxpageItem>;
  ThemeboxpageItems?: Maybe<ThemeboxpageItems>;
  ThemeboxpagecollectionItem?: Maybe<ThemeboxpagecollectionItem>;
  ThemeboxpagecollectionItems?: Maybe<ThemeboxpagecollectionItems>;
  TopbannerItem?: Maybe<TopbannerItem>;
  TopbannerItems?: Maybe<TopbannerItems>;
};


export type QueryTypeActiontickerItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeActiontickerItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypeBlogcategoryItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeBlogcategoryItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<BlogcategoryFilterQuery>;
};


export type QueryTypeBlogoverviewItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeBlogoverviewItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<BlogoverviewFilterQuery>;
};


export type QueryTypeBlogpageItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeBlogpageItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<BlogpageFilterQuery>;
};


export type QueryTypeCollectionItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeCollectionItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<CollectionFilterQuery>;
};


export type QueryTypeContentNodeArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeContentNodesArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypeDatasourceEntriesArgs = {
  datasource?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
};


export type QueryTypeDatasourcesArgs = {
  search?: Maybe<Scalars['String']>;
  by_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryTypeDynamicpageItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeDynamicpageItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<DynamicpageFilterQuery>;
};


export type QueryTypeFooterItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeFooterItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypeFooternewItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeFooternewItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypeHomeItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeHomeItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<HomeFilterQuery>;
};


export type QueryTypeHomecopyItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeHomecopyItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<HomecopyFilterQuery>;
};


export type QueryTypeHomesectionItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeHomesectionItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<HomesectionFilterQuery>;
};


export type QueryTypeLandingItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeLandingItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<LandingFilterQuery>;
};


export type QueryTypeLinksArgs = {
  starts_with?: Maybe<Scalars['String']>;
  paginated?: Maybe<Scalars['Boolean']>;
};


export type QueryTypeMealssettingsItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeMealssettingsItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<MealssettingsFilterQuery>;
};


export type QueryTypeNavigationItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeNavigationItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypeOverviewsettingsItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeOverviewsettingsItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<OverviewsettingsFilterQuery>;
};


export type QueryTypePageItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypePageItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypePdpsettingsItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypePdpsettingsItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypePersonItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypePersonItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<PersonFilterQuery>;
};


export type QueryTypePostItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypePostItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<PostFilterQuery>;
};


export type QueryTypeProductItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeProductItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<ProductFilterQuery>;
};


export type QueryTypeProductlistingItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeProductlistingItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<ProductlistingFilterQuery>;
};


export type QueryTypeTagsArgs = {
  starts_with?: Maybe<Scalars['String']>;
};


export type QueryTypeTermsandconditionsItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeTermsandconditionsItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypeThemeboxmealItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeThemeboxmealItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<ThemeboxmealFilterQuery>;
};


export type QueryTypeThemeboxoverviewItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeThemeboxoverviewItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
};


export type QueryTypeThemeboxpageItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeThemeboxpageItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<ThemeboxpageFilterQuery>;
};


export type QueryTypeThemeboxpagecollectionItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeThemeboxpagecollectionItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<ThemeboxpagecollectionFilterQuery>;
};


export type QueryTypeTopbannerItemArgs = {
  id: Scalars['ID'];
  find_by?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['Int']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};


export type QueryTypeTopbannerItemsArgs = {
  first_published_at_gt?: Maybe<Scalars['String']>;
  first_published_at_lt?: Maybe<Scalars['String']>;
  published_at_gt?: Maybe<Scalars['String']>;
  published_at_lt?: Maybe<Scalars['String']>;
  starts_with?: Maybe<Scalars['String']>;
  by_slugs?: Maybe<Scalars['String']>;
  excluding_slugs?: Maybe<Scalars['String']>;
  fallback_lang?: Maybe<Scalars['String']>;
  by_uuids?: Maybe<Scalars['String']>;
  by_uuids_ordered?: Maybe<Scalars['String']>;
  excluding_ids?: Maybe<Scalars['String']>;
  excluding_fields?: Maybe<Scalars['String']>;
  resolve_links?: Maybe<Scalars['String']>;
  resolve_relations?: Maybe<Scalars['String']>;
  from_release?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
  search_term?: Maybe<Scalars['String']>;
  is_startpage?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  with_tag?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  filter_query?: Maybe<Scalars['JsonScalar']>;
  filter_query_v2?: Maybe<TopbannerFilterQuery>;
};

export type RateLimit = {
  __typename?: 'RateLimit';
  maxCost: Scalars['Int'];
};

export type Space = {
  __typename?: 'Space';
  domain: Scalars['String'];
  id: Scalars['Int'];
  languageCodes: Array<Maybe<Scalars['String']>>;
  name: Scalars['String'];
  version: Scalars['Int'];
};

export type Story = {
  __typename?: 'Story';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<Scalars['JsonScalar']>;
  createdAt?: Maybe<Scalars['String']>;
  firstPublishedAt?: Maybe<Scalars['String']>;
  fullSlug?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isStartpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  metaData?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['String']>;
  releaseId?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sortByDate?: Maybe<Scalars['String']>;
  tagList?: Maybe<Array<Maybe<Scalars['String']>>>;
  translatedSlugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  name: Scalars['String'];
  taggingsCount: Scalars['Int'];
};

export type Tags = {
  __typename?: 'Tags';
  items: Array<Tag>;
};

export type TermsandconditionsComponent = {
  __typename?: 'TermsandconditionsComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  terms_and_conditions?: Maybe<Scalars['JsonScalar']>;
};

export type TermsandconditionsItem = {
  __typename?: 'TermsandconditionsItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<TermsandconditionsComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type TermsandconditionsItems = {
  __typename?: 'TermsandconditionsItems';
  items?: Maybe<Array<Maybe<TermsandconditionsItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ThemeboxmealComponent = {
  __typename?: 'ThemeboxmealComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  background_color?: Maybe<Scalars['JsonScalar']>;
  component?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['JsonScalar']>;
  font_color?: Maybe<Scalars['JsonScalar']>;
  image?: Maybe<Asset>;
  quantity?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  text_block_background_color?: Maybe<Scalars['JsonScalar']>;
  texture_type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ThemeboxmealFilterQuery = {
  title?: Maybe<FilterQueryOperations>;
  shortDescription?: Maybe<FilterQueryOperations>;
  texture_type?: Maybe<FilterQueryOperations>;
  quantity?: Maybe<FilterQueryOperations>;
};

export type ThemeboxmealItem = {
  __typename?: 'ThemeboxmealItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ThemeboxmealComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ThemeboxmealItems = {
  __typename?: 'ThemeboxmealItems';
  items?: Maybe<Array<Maybe<ThemeboxmealItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ThemeboxoverviewComponent = {
  __typename?: 'ThemeboxoverviewComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  component?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['BlockScalar']>;
  pageSections?: Maybe<Scalars['BlockScalar']>;
  seo?: Maybe<Scalars['JsonScalar']>;
};

export type ThemeboxoverviewItem = {
  __typename?: 'ThemeboxoverviewItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ThemeboxoverviewComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ThemeboxoverviewItems = {
  __typename?: 'ThemeboxoverviewItems';
  items?: Maybe<Array<Maybe<ThemeboxoverviewItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ThemeboxpageComponent = {
  __typename?: 'ThemeboxpageComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  backgroud_color?: Maybe<Scalars['JsonScalar']>;
  badge?: Maybe<Asset>;
  badge_pos_m_x?: Maybe<Scalars['String']>;
  badge_pos_m_y?: Maybe<Scalars['String']>;
  badge_pos_x?: Maybe<Scalars['String']>;
  badge_pos_y?: Maybe<Scalars['String']>;
  badge_width?: Maybe<Scalars['String']>;
  box_advantages?: Maybe<Scalars['BlockScalar']>;
  box_image?: Maybe<Asset>;
  box_image_m?: Maybe<Asset>;
  component?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dynamic_sections?: Maybe<Scalars['BlockScalar']>;
  dynamic_sections2?: Maybe<Scalars['BlockScalar']>;
  header?: Maybe<Scalars['BlockScalar']>;
  header_backgroud_color?: Maybe<Scalars['JsonScalar']>;
  header_font_color?: Maybe<Scalars['JsonScalar']>;
  header_text_block_background_color?: Maybe<Scalars['JsonScalar']>;
  image_cover_toggle?: Maybe<Scalars['Boolean']>;
  mealBoxCollectionHandle?: Maybe<Scalars['String']>;
  mealsInBox?: Maybe<Array<Maybe<Story>>>;
  mealsInBoxTitle?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  shopifyProduct?: Maybe<Scalars['JsonScalar']>;
  specs?: Maybe<Scalars['BlockScalar']>;
  title?: Maybe<Scalars['String']>;
  use_badge?: Maybe<Scalars['Boolean']>;
};


export type ThemeboxpageComponentMealsInBoxArgs = {
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
};

export type ThemeboxpageFilterQuery = {
  image_cover_toggle?: Maybe<FilterQueryOperations>;
  title?: Maybe<FilterQueryOperations>;
  mealsInBoxTitle?: Maybe<FilterQueryOperations>;
  mealsInBox?: Maybe<FilterQueryOperations>;
  mealBoxCollectionHandle?: Maybe<FilterQueryOperations>;
  use_badge?: Maybe<FilterQueryOperations>;
  badge_width?: Maybe<FilterQueryOperations>;
  badge_pos_x?: Maybe<FilterQueryOperations>;
  badge_pos_y?: Maybe<FilterQueryOperations>;
  badge_pos_m_x?: Maybe<FilterQueryOperations>;
  badge_pos_m_y?: Maybe<FilterQueryOperations>;
};

export type ThemeboxpageItem = {
  __typename?: 'ThemeboxpageItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ThemeboxpageComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ThemeboxpageItems = {
  __typename?: 'ThemeboxpageItems';
  items?: Maybe<Array<Maybe<ThemeboxpageItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ThemeboxpagecollectionComponent = {
  __typename?: 'ThemeboxpagecollectionComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  box_advantages?: Maybe<Scalars['BlockScalar']>;
  component?: Maybe<Scalars['String']>;
  dynamic_sections?: Maybe<Scalars['BlockScalar']>;
  header?: Maybe<Scalars['BlockScalar']>;
  mealsInBox?: Maybe<Array<Maybe<Story>>>;
  mealsInBoxTitle?: Maybe<Scalars['String']>;
  normalSizeCollectionHandle?: Maybe<Scalars['String']>;
  seo?: Maybe<Scalars['JsonScalar']>;
  text?: Maybe<Scalars['String']>;
  xlSizeCollectionHandle?: Maybe<Scalars['String']>;
};


export type ThemeboxpagecollectionComponentMealsInBoxArgs = {
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  language?: Maybe<Scalars['String']>;
  sort_by?: Maybe<Scalars['String']>;
};

export type ThemeboxpagecollectionFilterQuery = {
  normalSizeCollectionHandle?: Maybe<FilterQueryOperations>;
  xlSizeCollectionHandle?: Maybe<FilterQueryOperations>;
  mealsInBoxTitle?: Maybe<FilterQueryOperations>;
  mealsInBox?: Maybe<FilterQueryOperations>;
  text?: Maybe<FilterQueryOperations>;
};

export type ThemeboxpagecollectionItem = {
  __typename?: 'ThemeboxpagecollectionItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<ThemeboxpagecollectionComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type ThemeboxpagecollectionItems = {
  __typename?: 'ThemeboxpagecollectionItems';
  items?: Maybe<Array<Maybe<ThemeboxpagecollectionItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type TopbannerComponent = {
  __typename?: 'TopbannerComponent';
  _editable?: Maybe<Scalars['String']>;
  _uid?: Maybe<Scalars['String']>;
  buttonLink?: Maybe<Link>;
  buttonTitle?: Maybe<Scalars['String']>;
  button_color?: Maybe<Scalars['JsonScalar']>;
  button_shadow_color?: Maybe<Scalars['JsonScalar']>;
  component?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  image_mobile?: Maybe<Asset>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['JsonScalar']>;
  use_custom_button_color?: Maybe<Scalars['Boolean']>;
};

export type TopbannerFilterQuery = {
  buttonTitle?: Maybe<FilterQueryOperations>;
  use_custom_button_color?: Maybe<FilterQueryOperations>;
};

export type TopbannerItem = {
  __typename?: 'TopbannerItem';
  alternates?: Maybe<Array<Maybe<Alternate>>>;
  content?: Maybe<TopbannerComponent>;
  created_at?: Maybe<Scalars['String']>;
  default_full_slug?: Maybe<Scalars['String']>;
  first_published_at?: Maybe<Scalars['String']>;
  full_slug?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_startpage?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  meta_data?: Maybe<Scalars['JsonScalar']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['String']>;
  release_id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  sort_by_date?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  translated_slugs?: Maybe<Array<Maybe<TranslatedSlug>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type TopbannerItems = {
  __typename?: 'TopbannerItems';
  items?: Maybe<Array<Maybe<TopbannerItem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type TranslatedSlug = {
  __typename?: 'TranslatedSlug';
  lang: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type BlogPageBaseFragmentFragment = (
  { __typename?: 'BlogpageItem' }
  & Pick<BlogpageItem, 'uuid' | 'slug' | 'full_slug'>
  & { content?: Maybe<(
    { __typename?: 'BlogpageComponent' }
    & Pick<BlogpageComponent, 'text'>
    & { image?: Maybe<(
      { __typename?: 'Asset' }
      & ImageFragmentFragment
    )>, categories?: Maybe<Array<Maybe<(
      { __typename?: 'Story' }
      & Pick<Story, 'content'>
    )>>> }
  )> }
);

export type ImageFragmentFragment = (
  { __typename?: 'Asset' }
  & Pick<Asset, 'alt' | 'filename' | 'focus'>
);

export type ActionTickerQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type ActionTickerQuery = (
  { __typename?: 'QueryType' }
  & { ActiontickerItem?: Maybe<(
    { __typename?: 'ActiontickerItem' }
    & Pick<ActiontickerItem, 'published_at' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'ActiontickerComponent' }
      & Pick<ActiontickerComponent, 'items' | '_editable' | 'background_color' | 'text_color'>
    )> }
  )> }
);

export type BlogOverviewPageQueryVariables = Exact<{
  id: Scalars['ID'];
  lang?: Maybe<Scalars['String']>;
}>;


export type BlogOverviewPageQuery = (
  { __typename?: 'QueryType' }
  & { BlogoverviewItem?: Maybe<(
    { __typename?: 'BlogoverviewItem' }
    & Pick<BlogoverviewItem, 'slug'>
    & { content?: Maybe<(
      { __typename?: 'BlogoverviewComponent' }
      & Pick<BlogoverviewComponent, 'seo' | 'title'>
      & { bg?: Maybe<(
        { __typename?: 'Asset' }
        & ImageFragmentFragment
      )>, featuredItem?: Maybe<(
        { __typename?: 'Story' }
        & Pick<Story, 'createdAt' | 'slug' | 'content'>
      )> }
    )> }
  )> }
);

export type BlogPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BlogPageQuery = (
  { __typename?: 'QueryType' }
  & { BlogpageItem?: Maybe<(
    { __typename?: 'BlogpageItem' }
    & Pick<BlogpageItem, 'created_at'>
    & { content?: Maybe<(
      { __typename?: 'BlogpageComponent' }
      & Pick<BlogpageComponent, 'seo' | 'text' | 'content'>
      & { image?: Maybe<(
        { __typename?: 'Asset' }
        & ImageFragmentFragment
      )>, person?: Maybe<(
        { __typename?: 'Story' }
        & Pick<Story, 'content'>
      )>, categories?: Maybe<Array<Maybe<(
        { __typename?: 'Story' }
        & Pick<Story, 'content'>
      )>>> }
    )> }
    & BlogPageBaseFragmentFragment
  )> }
);

export type BlogPagesQueryVariables = Exact<{
  prefix?: Maybe<Scalars['String']>;
  perPage?: Maybe<Scalars['Int']>;
}>;


export type BlogPagesQuery = (
  { __typename?: 'QueryType' }
  & { BlogpageItems?: Maybe<(
    { __typename?: 'BlogpageItems' }
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'BlogpageItem' }
      & Pick<BlogpageItem, 'id' | 'slug' | 'full_slug' | 'created_at'>
      & { content?: Maybe<(
        { __typename?: 'BlogpageComponent' }
        & Pick<BlogpageComponent, 'description' | 'text' | 'content'>
        & { image?: Maybe<(
          { __typename?: 'Asset' }
          & ImageFragmentFragment
        )>, categories?: Maybe<Array<Maybe<(
          { __typename?: 'Story' }
          & Pick<Story, 'content'>
        )>>> }
      )> }
    )>>> }
  )> }
);

export type CollectionItemQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: Maybe<Scalars['String']>;
}>;


export type CollectionItemQuery = (
  { __typename?: 'QueryType' }
  & { CollectionItem?: Maybe<(
    { __typename?: 'CollectionItem' }
    & Pick<CollectionItem, 'full_slug' | 'uuid' | 'slug'>
    & { content?: Maybe<(
      { __typename?: 'CollectionComponent' }
      & Pick<CollectionComponent, 'title' | 'description' | 'additional_data' | 'page_title' | 'meta_keywords' | 'meta_description' | 'link_text' | '_editable'>
    )> }
  )> }
);

export type DynamicPagesQueryVariables = Exact<{
  filter?: Maybe<Scalars['JsonScalar']>;
  prefix?: Maybe<Scalars['String']>;
}>;


export type DynamicPagesQuery = (
  { __typename?: 'QueryType' }
  & { DynamicpageItems?: Maybe<(
    { __typename?: 'DynamicpageItems' }
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'DynamicpageItem' }
      & Pick<DynamicpageItem, 'slug' | 'full_slug' | 'published_at' | 'uuid'>
      & { translated_slugs?: Maybe<Array<Maybe<(
        { __typename?: 'TranslatedSlug' }
        & Pick<TranslatedSlug, 'lang' | 'path'>
      )>>> }
    )>>> }
  )> }
);

export type FooterQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FooterQuery = (
  { __typename?: 'QueryType' }
  & { FooterItem?: Maybe<(
    { __typename?: 'FooterItem' }
    & Pick<FooterItem, 'published_at' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'FooterComponent' }
      & Pick<FooterComponent, 'link_list' | '_editable'>
    )> }
  )> }
);

export type Footer_V2QueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type Footer_V2Query = (
  { __typename?: 'QueryType' }
  & { FooternewItem?: Maybe<(
    { __typename?: 'FooternewItem' }
    & Pick<FooternewItem, 'published_at' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'FooternewComponent' }
      & Pick<FooternewComponent, 'blocks' | 'font_color' | 'background_color' | 'footer_bottom_text_blocks' | 'footer_bottom_links' | '_editable'>
    )> }
  )> }
);

export type LinkFragmentFragment = (
  { __typename?: 'Link' }
  & Pick<Link, 'url' | 'cachedUrl' | 'email' | 'fieldtype' | 'id' | 'linktype'>
  & { story?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'uuid' | 'slug' | 'fullSlug'>
  )> }
);

export type HomeQueryVariables = Exact<{
  slug: Scalars['ID'];
  lang?: Maybe<Scalars['String']>;
}>;


export type HomeQuery = (
  { __typename?: 'QueryType' }
  & { HomeItem?: Maybe<(
    { __typename?: 'HomeItem' }
    & Pick<HomeItem, 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'HomeComponent' }
      & Pick<HomeComponent, 'seo' | 'title' | 'subtitle' | 'header_button' | 'meals_title' | 'meals_collection' | 'meals_buttonText' | 'about' | 'campaign' | 'reviews' | 'why' | 'how' | 'blog' | 'newsletter' | 'brands' | '_editable'>
      & { image?: Maybe<(
        { __typename?: 'Asset' }
        & ImageFragmentFragment
      )>, meals_gallery?: Maybe<Array<Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'filename' | 'alt'>
      )>>>, meals_link?: Maybe<(
        { __typename?: 'Link' }
        & LinkFragmentFragment
      )> }
    )> }
  )> }
);

export type MealssettingsQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type MealssettingsQuery = (
  { __typename?: 'QueryType' }
  & { MealssettingsItem?: Maybe<(
    { __typename?: 'MealssettingsItem' }
    & Pick<MealssettingsItem, 'published_at' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'MealssettingsComponent' }
      & Pick<MealssettingsComponent, 'title' | 'meals_groups'>
    )> }
  )> }
);

export type NavigationQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type NavigationQuery = (
  { __typename?: 'QueryType' }
  & { NavigationItem?: Maybe<(
    { __typename?: 'NavigationItem' }
    & Pick<NavigationItem, 'published_at' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'NavigationComponent' }
      & Pick<NavigationComponent, 'link_list' | '_editable'>
    )> }
  )> }
);

export type OverviewsettingsQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type OverviewsettingsQuery = (
  { __typename?: 'QueryType' }
  & { OverviewsettingsItem?: Maybe<(
    { __typename?: 'OverviewsettingsItem' }
    & Pick<OverviewsettingsItem, 'published_at' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'OverviewsettingsComponent' }
      & Pick<OverviewsettingsComponent, 'tips' | 'shopify_delivery_cost' | 'fh_delivery_cost' | 'disable_checkout' | 'disabled_checkout_text'>
    )> }
  )> }
);

export type PageByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  lang?: Maybe<Scalars['String']>;
}>;


export type PageByIdQuery = (
  { __typename?: 'QueryType' }
  & { DynamicpageItem?: Maybe<(
    { __typename?: 'DynamicpageItem' }
    & Pick<DynamicpageItem, 'uuid' | 'full_slug' | 'default_full_slug'>
    & { content?: Maybe<(
      { __typename?: 'DynamicpageComponent' }
      & Pick<DynamicpageComponent, 'sections' | 'seo' | 'noIndex' | '_editable'>
    )> }
  )> }
);

export type PageItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PageItemQuery = (
  { __typename?: 'QueryType' }
  & { PageItem?: Maybe<(
    { __typename?: 'PageItem' }
    & Pick<PageItem, 'full_slug' | 'uuid' | 'slug'>
    & { content?: Maybe<(
      { __typename?: 'PageComponent' }
      & Pick<PageComponent, 'body' | 'component' | '_uid' | '_editable'>
    )> }
  )> }
);

export type PdpsettingsQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type PdpsettingsQuery = (
  { __typename?: 'QueryType' }
  & { PdpsettingsItem?: Maybe<(
    { __typename?: 'PdpsettingsItem' }
    & Pick<PdpsettingsItem, 'published_at' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'PdpsettingsComponent' }
      & { banner_image?: Maybe<(
        { __typename?: 'Asset' }
        & ImageFragmentFragment
      )> }
    )> }
  )> }
);

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductByIdQuery = (
  { __typename?: 'QueryType' }
  & { ProductItem?: Maybe<(
    { __typename?: 'ProductItem' }
    & Pick<ProductItem, 'uuid' | 'slug'>
    & { content?: Maybe<(
      { __typename?: 'ProductComponent' }
      & Pick<ProductComponent, '_editable' | 'featured_products' | 'featured_products_title'>
    )> }
  )> }
);

export type ProductsQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type ProductsQuery = (
  { __typename?: 'QueryType' }
  & { ProductlistingItem?: Maybe<(
    { __typename?: 'ProductlistingItem' }
    & Pick<ProductlistingItem, 'id' | 'name' | 'slug' | 'uuid'>
    & { content?: Maybe<(
      { __typename?: 'ProductlistingComponent' }
      & Pick<ProductlistingComponent, 'title' | 'description' | 'seo' | '_editable' | '_uid'>
    )> }
  )> }
);

export type TermsAndConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TermsAndConditionsQuery = (
  { __typename?: 'QueryType' }
  & { TermsandconditionsItems?: Maybe<(
    { __typename?: 'TermsandconditionsItems' }
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'TermsandconditionsItem' }
      & { content?: Maybe<(
        { __typename?: 'TermsandconditionsComponent' }
        & Pick<TermsandconditionsComponent, '_uid' | '_editable' | 'terms_and_conditions'>
      )> }
    )>>> }
  )> }
);

export type ThemeboxpageItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ThemeboxpageItemQuery = (
  { __typename?: 'QueryType' }
  & { ThemeboxpageItem?: Maybe<(
    { __typename?: 'ThemeboxpageItem' }
    & Pick<ThemeboxpageItem, 'full_slug' | 'uuid' | 'slug'>
    & { content?: Maybe<(
      { __typename?: 'ThemeboxpageComponent' }
      & Pick<ThemeboxpageComponent, 'seo' | '_editable' | '_uid' | 'component' | 'shopifyProduct' | 'dynamic_sections' | 'header' | 'box_advantages' | 'mealsInBoxTitle' | 'mealBoxCollectionHandle' | 'title' | 'specs' | 'description' | 'image_cover_toggle' | 'header_backgroud_color' | 'backgroud_color' | 'header_font_color' | 'header_text_block_background_color' | 'use_badge' | 'badge_pos_m_x' | 'badge_pos_m_y' | 'badge_pos_x' | 'badge_pos_y' | 'badge_width'>
      & { mealsInBox?: Maybe<Array<Maybe<(
        { __typename?: 'Story' }
        & Pick<Story, 'uuid' | 'content'>
      )>>>, box_image?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'filename' | 'alt'>
      )>, box_image_m?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'filename' | 'alt'>
      )>, badge?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'filename' | 'alt'>
      )> }
    )> }
  )> }
);

export type ThemeboxpageItemEnglishQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ThemeboxpageItemEnglishQuery = (
  { __typename?: 'QueryType' }
  & { ThemeboxpageItem?: Maybe<(
    { __typename?: 'ThemeboxpageItem' }
    & Pick<ThemeboxpageItem, 'full_slug' | 'uuid' | 'slug'>
    & { content?: Maybe<(
      { __typename?: 'ThemeboxpageComponent' }
      & Pick<ThemeboxpageComponent, 'seo' | '_editable' | '_uid' | 'component' | 'shopifyProduct' | 'dynamic_sections' | 'dynamic_sections2' | 'header' | 'box_advantages' | 'mealsInBoxTitle' | 'mealBoxCollectionHandle' | 'title' | 'specs' | 'description' | 'image_cover_toggle' | 'header_backgroud_color' | 'backgroud_color' | 'header_font_color' | 'header_text_block_background_color' | 'use_badge' | 'badge_pos_m_x' | 'badge_pos_m_y' | 'badge_pos_x' | 'badge_pos_y' | 'badge_width'>
      & { mealsInBox?: Maybe<Array<Maybe<(
        { __typename?: 'Story' }
        & Pick<Story, 'content'>
      )>>>, box_image?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'filename' | 'alt'>
      )>, box_image_m?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'filename' | 'alt'>
      )>, badge?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'filename' | 'alt'>
      )> }
    )> }
  )> }
);

export type ThemeboxpageItemsQueryVariables = Exact<{
  prefix?: Maybe<Scalars['String']>;
}>;


export type ThemeboxpageItemsQuery = (
  { __typename?: 'QueryType' }
  & { ThemeboxpageItems?: Maybe<(
    { __typename?: 'ThemeboxpageItems' }
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'ThemeboxpageItem' }
      & Pick<ThemeboxpageItem, 'slug'>
      & { content?: Maybe<(
        { __typename?: 'ThemeboxpageComponent' }
        & Pick<ThemeboxpageComponent, 'shopifyProduct' | 'header'>
      )> }
    )>>> }
  )> }
);

export type ThemeBoxesOverviewQueryVariables = Exact<{
  id: Scalars['ID'];
  lang?: Maybe<Scalars['String']>;
}>;


export type ThemeBoxesOverviewQuery = (
  { __typename?: 'QueryType' }
  & { ThemeboxoverviewItem?: Maybe<(
    { __typename?: 'ThemeboxoverviewItem' }
    & Pick<ThemeboxoverviewItem, 'full_slug' | 'uuid' | 'slug'>
    & { content?: Maybe<(
      { __typename?: 'ThemeboxoverviewComponent' }
      & Pick<ThemeboxoverviewComponent, 'seo' | '_editable' | '_uid' | 'component' | 'header' | 'pageSections'>
    )> }
  )> }
);

export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on Asset {
  alt
  filename
  focus
}
    `;
export const BlogPageBaseFragmentFragmentDoc = gql`
    fragment BlogPageBaseFragment on BlogpageItem {
  uuid
  slug
  full_slug
  content {
    text
    image {
      ...ImageFragment
    }
    categories {
      content
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const LinkFragmentFragmentDoc = gql`
    fragment LinkFragment on Link {
  url
  cachedUrl
  email
  fieldtype
  id
  linktype
  story {
    uuid
    slug
    fullSlug
  }
}
    `;
export const ActionTickerDocument = gql`
    query actionTicker($slug: ID!) {
  ActiontickerItem(id: $slug, resolve_links: "url") {
    published_at
    content {
      items
      _editable
      background_color
      text_color
    }
    uuid
  }
}
    `;
export const BlogOverviewPageDocument = gql`
    query blogOverviewPage($id: ID!, $lang: String = "default") {
  BlogoverviewItem(id: $id, language: $lang) {
    slug
    content {
      seo
      title
      bg {
        ...ImageFragment
      }
      featuredItem(resolve_relations: "categories") {
        createdAt
        slug
        content
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const BlogPageDocument = gql`
    query blogPage($id: ID!) {
  BlogpageItem(id: $id) {
    ...BlogPageBaseFragment
    created_at
    content {
      seo
      text
      image {
        ...ImageFragment
      }
      content
      person {
        content
      }
      categories {
        content
      }
    }
  }
}
    ${BlogPageBaseFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const BlogPagesDocument = gql`
    query blogPages($prefix: String = "", $perPage: Int) {
  BlogpageItems(
    resolve_relations: "categories.category"
    starts_with: $prefix
    per_page: $perPage
  ) {
    items {
      id
      slug
      full_slug
      created_at
      content {
        description
        image {
          ...ImageFragment
        }
        text
        categories {
          content
        }
        content
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const CollectionItemDocument = gql`
    query collectionItem($slug: ID!, $lang: String = "default") {
  CollectionItem(id: $slug, language: $lang) {
    full_slug
    uuid
    slug
    content {
      title
      description
      additional_data
      page_title
      meta_keywords
      meta_description
      link_text
      _editable
    }
  }
}
    `;
export const DynamicPagesDocument = gql`
    query dynamicPages($filter: JsonScalar, $prefix: String = "") {
  DynamicpageItems(filter_query: $filter, per_page: 100, starts_with: $prefix) {
    items {
      slug
      full_slug
      published_at
      uuid
      translated_slugs {
        lang
        path
      }
    }
  }
}
    `;
export const FooterDocument = gql`
    query footer($slug: ID!) {
  FooterItem(id: $slug, resolve_links: "url") {
    published_at
    content {
      link_list
      _editable
    }
    uuid
  }
}
    `;
export const Footer_V2Document = gql`
    query footer_v2($slug: ID!) {
  FooternewItem(id: $slug, resolve_links: "url") {
    published_at
    content {
      blocks
      font_color
      background_color
      footer_bottom_text_blocks
      footer_bottom_links
      _editable
    }
    uuid
  }
}
    `;
export const HomeDocument = gql`
    query home($slug: ID!, $lang: String = "default") {
  HomeItem(id: $slug, resolve_links: "url", language: $lang) {
    content {
      seo
      title
      subtitle
      image {
        ...ImageFragment
      }
      header_button
      meals_title
      meals_gallery {
        filename
        alt
      }
      meals_collection
      meals_buttonText
      meals_link {
        ...LinkFragment
      }
      about
      campaign
      reviews
      why
      how
      blog
      newsletter
      brands
      _editable
    }
    uuid
  }
}
    ${ImageFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const MealssettingsDocument = gql`
    query mealssettings($slug: ID!) {
  MealssettingsItem(id: $slug, resolve_links: "url") {
    published_at
    content {
      title
      meals_groups
    }
    uuid
  }
}
    `;
export const NavigationDocument = gql`
    query navigation($slug: ID!) {
  NavigationItem(id: $slug, resolve_links: "url") {
    published_at
    content {
      link_list
      _editable
    }
    uuid
  }
}
    `;
export const OverviewsettingsDocument = gql`
    query overviewsettings($slug: ID!) {
  OverviewsettingsItem(id: $slug, resolve_links: "url") {
    published_at
    uuid
    content {
      tips
      shopify_delivery_cost
      fh_delivery_cost
      disable_checkout
      disabled_checkout_text
    }
    uuid
  }
}
    `;
export const PageByIdDocument = gql`
    query pageById($id: ID!, $lang: String = "default") {
  DynamicpageItem(
    id: $id
    resolve_relations: "contact_form.termsAndConditions"
    resolve_links: "url"
    language: $lang
  ) {
    content {
      sections
      seo
      noIndex
      _editable
    }
    uuid
    full_slug
    default_full_slug
  }
}
    `;
export const PageItemDocument = gql`
    query pageItem($id: ID!) {
  PageItem(id: $id) {
    full_slug
    uuid
    slug
    content {
      body
      component
      _uid
      _editable
    }
  }
}
    `;
export const PdpsettingsDocument = gql`
    query pdpsettings($slug: ID!) {
  PdpsettingsItem(id: $slug, resolve_links: "url") {
    published_at
    content {
      banner_image {
        ...ImageFragment
      }
    }
    uuid
  }
}
    ${ImageFragmentFragmentDoc}`;
export const ProductByIdDocument = gql`
    query productById($id: ID!) {
  ProductItem(id: $id) {
    content {
      _editable
      featured_products
      featured_products_title
    }
    uuid
    slug
  }
}
    `;
export const ProductsDocument = gql`
    query products($slug: ID!) {
  ProductlistingItem(id: $slug) {
    id
    name
    slug
    uuid
    content {
      title
      description
      seo
      _editable
      _uid
    }
  }
}
    `;
export const TermsAndConditionsDocument = gql`
    query termsAndConditions {
  TermsandconditionsItems {
    items {
      content {
        _uid
        _editable
        terms_and_conditions
      }
    }
  }
}
    `;
export const ThemeboxpageItemDocument = gql`
    query themeboxpageItem($id: ID!) {
  ThemeboxpageItem(id: $id) {
    full_slug
    uuid
    slug
    content {
      seo
      _editable
      _uid
      component
      shopifyProduct
      dynamic_sections
      header
      box_advantages
      mealsInBoxTitle
      mealsInBox {
        uuid
        content
      }
      mealBoxCollectionHandle
      title
      specs
      description
      box_image {
        filename
        alt
      }
      box_image_m {
        filename
        alt
      }
      image_cover_toggle
      header_backgroud_color
      backgroud_color
      header_font_color
      header_text_block_background_color
      use_badge
      badge {
        filename
        alt
      }
      badge_pos_m_x
      badge_pos_m_y
      badge_pos_x
      badge_pos_y
      badge_width
    }
  }
}
    `;
export const ThemeboxpageItemEnglishDocument = gql`
    query themeboxpageItemEnglish($id: ID!) {
  ThemeboxpageItem(id: $id) {
    full_slug
    uuid
    slug
    content {
      seo
      _editable
      _uid
      component
      shopifyProduct
      dynamic_sections
      dynamic_sections2
      header
      box_advantages
      mealsInBoxTitle
      mealsInBox(language: "en") {
        content
      }
      mealBoxCollectionHandle
      title
      specs
      description
      box_image {
        filename
        alt
      }
      box_image_m {
        filename
        alt
      }
      image_cover_toggle
      header_backgroud_color
      backgroud_color
      header_font_color
      header_text_block_background_color
      use_badge
      badge {
        filename
        alt
      }
      badge_pos_m_x
      badge_pos_m_y
      badge_pos_x
      badge_pos_y
      badge_width
    }
  }
}
    `;
export const ThemeboxpageItemsDocument = gql`
    query themeboxpageItems($prefix: String = "") {
  ThemeboxpageItems(starts_with: $prefix) {
    items {
      slug
      content {
        shopifyProduct
        header
      }
    }
  }
}
    `;
export const ThemeBoxesOverviewDocument = gql`
    query themeBoxesOverview($id: ID!, $lang: String = "default") {
  ThemeboxoverviewItem(id: $id, language: $lang) {
    full_slug
    uuid
    slug
    content {
      seo
      _editable
      _uid
      component
      header
      pageSections
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    actionTicker(variables: ActionTickerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ActionTickerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActionTickerQuery>(ActionTickerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'actionTicker');
    },
    blogOverviewPage(variables: BlogOverviewPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BlogOverviewPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogOverviewPageQuery>(BlogOverviewPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'blogOverviewPage');
    },
    blogPage(variables: BlogPageQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BlogPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPageQuery>(BlogPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'blogPage');
    },
    blogPages(variables?: BlogPagesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BlogPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPagesQuery>(BlogPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'blogPages');
    },
    collectionItem(variables: CollectionItemQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CollectionItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CollectionItemQuery>(CollectionItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'collectionItem');
    },
    dynamicPages(variables?: DynamicPagesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DynamicPagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DynamicPagesQuery>(DynamicPagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dynamicPages');
    },
    footer(variables: FooterQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FooterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FooterQuery>(FooterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'footer');
    },
    footer_v2(variables: Footer_V2QueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Footer_V2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<Footer_V2Query>(Footer_V2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'footer_v2');
    },
    home(variables: HomeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HomeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomeQuery>(HomeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'home');
    },
    mealssettings(variables: MealssettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MealssettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MealssettingsQuery>(MealssettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mealssettings');
    },
    navigation(variables: NavigationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<NavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavigationQuery>(NavigationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'navigation');
    },
    overviewsettings(variables: OverviewsettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OverviewsettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OverviewsettingsQuery>(OverviewsettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'overviewsettings');
    },
    pageById(variables: PageByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PageByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageByIdQuery>(PageByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pageById');
    },
    pageItem(variables: PageItemQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PageItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PageItemQuery>(PageItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pageItem');
    },
    pdpsettings(variables: PdpsettingsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PdpsettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PdpsettingsQuery>(PdpsettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pdpsettings');
    },
    productById(variables: ProductByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductByIdQuery>(ProductByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productById');
    },
    products(variables: ProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductsQuery>(ProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'products');
    },
    termsAndConditions(variables?: TermsAndConditionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TermsAndConditionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TermsAndConditionsQuery>(TermsAndConditionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'termsAndConditions');
    },
    themeboxpageItem(variables: ThemeboxpageItemQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ThemeboxpageItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThemeboxpageItemQuery>(ThemeboxpageItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'themeboxpageItem');
    },
    themeboxpageItemEnglish(variables: ThemeboxpageItemEnglishQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ThemeboxpageItemEnglishQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThemeboxpageItemEnglishQuery>(ThemeboxpageItemEnglishDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'themeboxpageItemEnglish');
    },
    themeboxpageItems(variables?: ThemeboxpageItemsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ThemeboxpageItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThemeboxpageItemsQuery>(ThemeboxpageItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'themeboxpageItems');
    },
    themeBoxesOverview(variables: ThemeBoxesOverviewQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ThemeBoxesOverviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThemeBoxesOverviewQuery>(ThemeBoxesOverviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'themeBoxesOverview');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;